import _ from 'lodash'

export const getContracts = (state, props) => _.get(state, 'leadContractActions.leadContracts.data')
export const getContractsTemplates = (state, props) =>
  _.get(state, 'contractTemplate.contractTemplates.data')
export const getContractPaymentScheduleTemplate = (state, props) =>
  _.get(state, 'contractActions.contractPaymentScheduleTemplate.data')
export const getContractPaymentSchedules = (state, props) =>
  _.get(state, 'contractActions.contractPaymentSchedules.data')
export const getContractIdParam = (state, props) => _.get(props, 'match.params.contractId')
export const getUploadingAttachment = (state, props) =>
  _.get(state, 'leadContractActions.uploadingAttachment')



// WEBPACK FOOTER //
// ./src/selectors/lead/contracts.js